
export enum BatteryType {
  LiIonLFP= 'LiIonLFP',
  LiIonLTO= 'LiIonLTO',
  LiIonNMC= 'LiIonNMC',
  NaIon= 'NaIon',

}